import { Moment } from 'moment';
import useDefaultSettings from '../../DefaultSettings/Hooks/useDefaultSettings';
import moment from 'moment';
import { useMemo } from 'react';
import { ePrescriptionDeliveryOptions } from '../Components/EPrescriptionIssuePrescription';
import useTranslation from '../../../Hooks/useTranslation';
import { SelectValue } from '../../../Components/Base/Select/Select';

export default function usePrescriptionHelper() {
	const {
		defaultPrescriptionValidityInDays,
		deliveryOfPrescriptionIdentifier,
	} = useDefaultSettings();
	const { t } = useTranslation();

	const prescriptionDefaultValues = useMemo(() => {
		const today = moment();
		let validTo: Moment | undefined = undefined;

		if (defaultPrescriptionValidityInDays) {
			validTo = today.add(+parseInt(defaultPrescriptionValidityInDays), 'days');
		}

		const notification: SelectValue | undefined =
			ePrescriptionDeliveryOptions.find(
				i => i.value === deliveryOfPrescriptionIdentifier,
			);

		if (notification) {
			notification['label'] = t(notification.label);
		}

		return {
			issuePrescription: {
				validTo,
				notification,
			},
		};
	}, [defaultPrescriptionValidityInDays]);

	return { prescriptionDefaultValues };
}
